// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import React from "react";
import { IndexForms } from "@hex-insights/app-modules";
import { FormState } from "@hex-insights/forms";
import { PostFilterInput, PostOrder, usePostPaginationQuery } from "../../../../Utilities";

export type PaginationFormProps = {
	formState: FormState<IndexForms.PaginationFormValues>;
	filters: PostFilterInput | PostFilterInput[] | null;
	order: PostOrder | null;
	setPaginationInfo: (action: React.SetStateAction<IndexForms.PaginationInfo>) => void;
} & Pick<IndexForms.PaginationFormProps, "onNavigate">;

/**
 * Pagination form of the Post model.
 */
export function PaginationForm({ formState, filters, order, setPaginationInfo, onNavigate }: PaginationFormProps) {
	const { loading, data } = usePostPaginationQuery({ variables: { filters, order } });

	return (
		<IndexForms.PaginationForm
			formState={formState}
			isLoading={loading}
			connection={data?.postConnection}
			setPaginationInfo={setPaginationInfo}
			onNavigate={onNavigate}
		/>
	);
}
